import React from 'react';
import { colors } from '@tempmee/tailwind';
import { OutlineCheckIcon } from '@tempmee/react-icons';

export const renderIntroductionLine = (title: string) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      margin: 2,
      justifyContent: 'flex-start',
      alignItems: 'center',
    }}
  >
    <div
      style={{
        backgroundColor: colors.neutral[600],
        borderRadius: 50,
        width: 6,
        height: 6,
        marginRight: 4,
        marginLeft: 10,
      }}
    />
    <p
      className="card-text"
      style={{
        fontFamily: 'Nunito',
        width: '90%',
        fontSize: 16,
        margin: 5,
        color: colors.neutral[600],
        fontWeight: 400,
      }}
    >
      {title}
    </p>
  </div>
);

export const renderPoints = (text: string) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginRight: 30,
    }}
  >
    <OutlineCheckIcon size={25} color={colors.success[400]} />
    <p
      style={{
        color: colors.neutral[500],
        fontFamily: 'Nunito',
        fontWeight: 400,
        fontSize: 16,
        letterSpacing: 0,
        margin: 0,
      }}
    >
      {text}
    </p>
  </div>
);
